export class ConstantInfoVariables {
    static readonly LeanStandardRange = 'Jobs that fit into the Lean Standard Range (LSR) are greater than $10M in revenue and are included in the monthly BPC report (SAP).';

    static readonly RoadmapGoalNoComments = 'This version has no comments, click to add or view all comments.';
    static readonly RoadmapGoalHasComments = 'This goal has a comment, click to view.';

    static readonly RoadmapGoalIsRecurring = 'This is a recurring goal, if the goal is being met to standard, target date for goal to be evaluated on a recurring schedule.  If the goal is not being met target date should be set to when the goal will be achieved.';
    static readonly RoadmapGoalIsRecurringShort = 'This is a recurring goal.';
    static readonly RoadmapGoalNotRecurring = 'This is a one time goal.';
}

/** The lean standard range variable for volume, this is a demarkation point for projects to be in lean standard range */
export const VolumeLSR = 10000000;

/** Url on SharePoint for the User Guide */
export const UserGuideUrl = 'https://tcco.sharepoint.com/:b:/r/sites/lean/Shared%20Documents/2023.02.03%20Lean%20Dashboard%20and%20Roadmap%20Guide.pdf?csf=1&web=1&e=gmYRJG';
